module.exports = __webpack_public_path__ + "img/5.1a4b218f.jpg";